import LocationName from '@/components/hr/location-name.vue'
import EmployeeName from '@/components/hr/employee-name.vue'
import Uploader from '@/components/hr/uploader.vue'
import ImagePreview from '@/components/hr/image-preview.vue'
import HeaderBar from '@/components/base/header-bar.vue'
import BonusView from '@/components/shifts/bonus-view.vue'
import BonusList from '@/components/shifts/bonus-list.vue'
import InternalNotesWidget from '@/components/widgets/internal-notes.vue'

export default [
  LocationName,
  EmployeeName,
  Uploader,
  ImagePreview,
  HeaderBar,
  BonusView,
  BonusList,
  InternalNotesWidget,
]
